type EMobilityTab = 'charging-sessions' | 'charging-cards' | 'wallbox' | 'vehicle-integration'

export const getEMobilityTabRouteV1 = (installationId: string | number = ':installationId', storageId?: string, tabName?: EMobilityTab): string => {
  const resolvedTabName = tabName ?? storageId

  if (tabName && storageId) {
    return `/e-mobility/${installationId}/${storageId}/${tabName}`
  }
  return `/e-mobility/${installationId}/${resolvedTabName || ':tabName'}`
}
